import { Command, HttpMethod } from "~/extensions/api";
export class Login extends Command {
    constructor(data, password) {
        super(HttpMethod.Post, "auth/login");
        this.loginId = data.loginId;
        this.password = password;
        this.appJsHash = data.appJsHash;
        this.vendorJsHash = data.vendorJsHash;
    }
    loginId = "";
    password = "";
    appJsHash = "";
    vendorJsHash = "";
}
